export const PATIENT_INVOICEABLES_BUFFER_COL_ID = 'patient_invoiceables_buffer';
